module.exports = __webpack_public_path__ + "static/media/11.02f2ecef.wav";